import { render, staticRenderFns } from "./UserUsage.vue?vue&type=template&id=1f5dc6c8&scoped=true"
import script from "./UserUsage.vue?vue&type=script&lang=js"
export * from "./UserUsage.vue?vue&type=script&lang=js"
import style0 from "./UserUsage.vue?vue&type=style&index=0&id=1f5dc6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5dc6c8",
  null
  
)

export default component.exports